(() => {
  const dialog = document.getElementById('CatterpodDiscount');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const key = 'catterpod-founder10-popup-v1';
  const params = new URLSearchParams(location.search);
  const returned = params.get('customer_posted') === 'true' && location.hash === '#CatterpodDiscountForm';
  const success = dialog.querySelector('[data-discount-success]');
  const error = dialog.querySelector('[data-discount-error]');
  let previousFocus;
  const store = (state) => { try { localStorage.setItem(key, JSON.stringify({state, at: Date.now()})); } catch (_) {} };
  const open = () => {
    if (Date.now() >= Date.parse(dialog.dataset.offerEnd) || dialog.open) return;
    // Avoid opening over another modal or the cart drawer.
    if (document.querySelector('dialog[open], cart-drawer.active')) return;
    previousFocus = document.activeElement;
    dialog.showModal();
    if (!success && !returned) store('shown');
    document.documentElement.classList.add('cp-discount-open');
    dialog.querySelector(success ? '[data-discount-close]' : '#CpDiscountEmail')?.focus();
  };
  dialog.querySelectorAll('[data-discount-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
  dialog.addEventListener('click', (event) => { if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close(); } });
  dialog.addEventListener('close', () => { store(success || returned ? 'submitted' : 'dismissed'); document.documentElement.classList.remove('cp-discount-open'); previousFocus?.focus(); });
  dialog.querySelector('form')?.addEventListener('submit', () => { try { sessionStorage.setItem(key, 'pending'); } catch (_) {} });
  let pending = false;
  try { pending = sessionStorage.getItem(key) === 'pending'; sessionStorage.removeItem(key); } catch (_) {}
  if (success || error || returned || (pending && location.hash === '#CatterpodDiscountForm')) {
    if (success || returned) store('submitted');
    open();
    return;
  }
  try {
    const saved = JSON.parse(localStorage.getItem(key) || 'null');
    if (saved && (saved.state === 'submitted' || Date.now() - saved.at < 24 * 60 * 60 * 1000)) return;
  } catch (_) {}
  if (!window.Shopify?.designMode) setTimeout(open, 2500);
})();
